/**
 * Number and Currency Utility Functions
 * Number formatting, currency handling, and mathematical utilities
 */

export const formatCurrency = (
  amount: number | string,
  currency: string = '₺',
  decimals: number = 2
): string => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) {
    return `0.00 ${currency}`;
  }

  return `${numAmount.toFixed(decimals)} ${currency}`;
};

export const formatNumber = (num: number | string, decimals: number = 0): string => {
  const numValue = typeof num === 'string' ? parseFloat(num) : num;

  if (isNaN(numValue)) {
    return '0';
  }

  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(numValue);
};

export const calculatePercentage = (value: number, total: number): number => {
  if (total === 0) {
    return 0;
  }
  return Math.round((value / total) * 100);
};
